import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Container as ContainerBase } from 'components/misc/Layouts';
import tw from 'twin.macro';
import styled from 'styled-components';
import illustration from 'images/login-illustration.svg';
import logo from 'images/logo.svg';
import { recuperarPassword } from 'scripts/forgotPasswordScript';
import { ERROR_ENVIO_EMAIL } from 'constants/emailMessages';

const Container = tw(ContainerBase)`min-h-screen bg-[#99cdb6] text-white font-medium flex justify-center`;
const Content = tw.div`max-w-screen-xl m-0 sm:mx-20 sm:my-16 bg-white text-gray-900 shadow sm:rounded-lg flex justify-center flex-1`;
const MainContainer = tw.div`lg:w-1/2 xl:w-5/12 p-6 sm:p-12`;
const LogoLink = tw.a``;
const LogoImage = tw.img`w-40 h-40 mx-auto rounded-full`;
const MainContent = tw.div`mt-12 flex flex-col items-center`;
const Heading = tw.h1`text-2xl xl:text-3xl font-extrabold`;
const FormContainer = tw.div`w-full flex-1 mt-8`;

const Form = tw.form`mx-auto max-w-xs`;
const Input = tw.input`w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5 first:mt-0`;
const SubmitButton = styled.button`
	${tw`mt-5 tracking-wide font-semibold bg-primary-500 text-gray-100 w-full py-4 rounded-lg hover:bg-primary-900 transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none`}
	.text {
		${tw`ml-3`}
	}
`;
const IllustrationContainer = tw.div`sm:rounded-r-lg flex-1 bg-purple-100 text-center hidden lg:flex justify-center`;
const IllustrationImage = styled.div`
	${(props) => `background-image: url("${props.imageSrc}");`}
	${tw`m-12 xl:m-16 w-full max-w-lg bg-contain bg-center bg-no-repeat`}
`;

export default ({
	logoLinkUrl = '/',
	illustrationImageSrc = illustration,
	headingText = 'Recuperar Contraseña',
	submitButtonText = 'Enviar Instrucciones',
	loginUrl = 'login',
}) => {
	const [email, setEmail] = useState('');
	const [error, setError] = useState('');

	const handleForgotPassword = async (event) => {
		event.preventDefault();
		recuperarPassword(email)
			.then((data) => {
				if (data?.emailEnviado === false) {
					toast.error(ERROR_ENVIO_EMAIL);
					return;
				}
				toast.success(data?.message || 'Se ha enviado un correo con instrucciones.');
				setEmail('');
				setError('');
			})
			.catch((error) => {
				setError(error?.message || 'Ocurrió un error');
			});
	};

	return (
		<Container>
			<Content>
				<MainContainer>
					<LogoLink href={logoLinkUrl}>
						<LogoImage src={logo} />
					</LogoLink>
					<MainContent>
						<Heading>{headingText}</Heading>
						<FormContainer>
							<Form onSubmit={handleForgotPassword}>
								<Input
									type="email"
									placeholder="Ingresa tu correo"
									value={email}
									onChange={(e) => setEmail(e.target.value)}
									required
								/>
								<SubmitButton type="submit">
									<span className="text">{submitButtonText}</span>
								</SubmitButton>
								{error && (
									<p style={{ color: 'red' }} tw="mt-5 text-center">
										{error}
									</p>
								)}
								<p tw="mt-6 text-xs text-gray-600 text-center">
									¿Recordaste tu contraseña?{' '}
									<a href={loginUrl} tw="border-b border-gray-500 border-dotted">
										Iniciar sesión
									</a>
								</p>
							</Form>
						</FormContainer>
					</MainContent>
				</MainContainer>
				<IllustrationContainer>
					<IllustrationImage imageSrc={illustrationImageSrc} />
				</IllustrationContainer>
			</Content>
		</Container>
	);
};
